export default function trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}



// WEBPACK FOOTER //
// ./src/component/select/utils/trim.js